import axios from 'axios';
import { baseUrl } from './baseUrl';
import { LOGIN } from '../features/partner/partnerSlice';
import { RESET_PASSWORD_INITIATE, RESET_PASSWORD_SUCCESS } from '../features/auth/authSlice';

// Partner Login
export const partnerLogin = async (data, dispatch, navigate, remember, toast, setLoginError) => {
    try {
        const res = await axios.post(`${baseUrl}/partner/auth/login`, {
            username: data.username,
            password: data.password
        });

        if(res.data.success){
            toast.success('Login Successful!');
            if(remember){
                localStorage.setItem('partner-t', res.data.accessToken);
                localStorage.setItem('partner-info', JSON.stringify(res.data.partnerInfo));
                localStorage.setItem('partner-type', res.data.partnerType);
            }
            else{
                sessionStorage.setItem('partner-t', res.data.accessToken);
                sessionStorage.setItem('partner-info', JSON.stringify(res.data.partnerInfo));
                sessionStorage.setItem('partner-type', res.data.partnerType);
            }
            setTimeout(() => {
                dispatch(LOGIN(res.data));
                navigate('/');
            }, 1000);
        }
        if(res.data.error){
            setLoginError(res.data.error.message);
        }
    } catch (err) {
        console.log(err);
        const errorMessage = err.response?.data?.error?.message || 'Login failed. Please try again.';
        setLoginError(errorMessage);
    }
}

// Partner Forgot Password
export const partnerForgotPassword = async (data, dispatch, navigate, toast) => {
    try {
        toast.loading('Sending OTP... Please wait!');
        const res = await axios.post(`${baseUrl}/partner/auth/forgot-password`, data);

        if(res.data.success){
            toast.dismiss();
            toast.success(res.data.message);
            dispatch(RESET_PASSWORD_INITIATE(data.username));
            setTimeout(() => {
                navigate('/forgotpasswordotp');
            }, 2000);
        }
        if(res.data.error){
            toast.dismiss();
            toast.error(res.data.error.message);
        }
    } catch (err) {
        toast.dismiss();
        console.log(err);
        toast.error(
            err.response?.data?.error?.message ||
            'An error occurred while sending the OTP. Please try again.'
        );
    }
}

// Partner Forgot Password OTP Send Again
export const sendOtpAgain = async (data, dispatch, toast) => {
    try {
        toast.loading('Sending OTP... Please wait!');
        const res = await axios.post(`${baseUrl}/partner/auth/forgot-password`, data);

        if(res.data.success){
            toast.dismiss();
            toast.success(res.data.message);
            dispatch(RESET_PASSWORD_INITIATE(data.username));
        }
        if(res.data.error){
            toast.dismiss();
            toast.error(res.data.error.message);
        }
    } catch (err) {
        toast.dismiss();
        console.log(err);
        toast.error(
            err.response?.data?.error?.message ||
            'An error occurred while sending the OTP. Please try again.'
        );
    }
}

// Partner Reset Password
export const partnerResetPassword = async (data, dispatch, navigate, toast) => {
    try {
        const res = await axios.post(`${baseUrl}/partner/auth/reset-password`, data);

        if(res.data.success){
            toast.success(res.data.message);
            setTimeout(() => {
                dispatch(RESET_PASSWORD_SUCCESS());
                navigate('/login');
            }, 2000);
        }
        if(res.data.error){
            toast.error(res.data.error.message);
        }
    } catch (err) {
        console.log(err);
        toast.error('Something went wrong!');
    }
}

// Get Partner Token (helper function)
export const getPartnerToken = () => {
    return sessionStorage.getItem('partner-t') || localStorage.getItem('partner-t');
}
